'use strict';

const Backbone = require('backbone');
const _ = require('lodash');

module.exports = {

    /*
     * Gets filters for the given key. Exposed for overwriting
     */
    getFilters: function (key) {
        const me = this;
        return me[key];
    },

    /*
     * Runs curation filters
     * filter actions can be asynchronous and are
     * always run in order.
     *
     * Actions should return or resolve to a view, a redirect string or
     * a falsy value
     */
    runFilters: function (key) {
        const me = this;

        const kickoff = new Backbone.$.Deferred();

        const filters = _.reduce(me.getFilters(key), function (deferred, filter) {
            if (me.isTornDown) {
                return deferred.resolve();
            }

            const filterEvaluation = new Backbone.$.Deferred();

            deferred.then(function (result) {
                if (result) {
                    return filterEvaluation.resolve(result);
                }

                const actionFn = (_.isFunction(filter) ? filter : filter.action);
                Backbone.$.when(actionFn(me))
                    .done(function () {
                        filterEvaluation.resolve.apply(this, arguments);
                    })
                    .fail(function (reason) {
                        // handle actionFn returning a promise that it later rejects.
                        filterEvaluation.reject(reason);
                    });
            }).fail(function (error) {
                filterEvaluation.reject(error);
            });

            return filterEvaluation;
        }, kickoff);

        kickoff.resolve();

        return filters;
    }
};
